import { Box, Card, CircularProgress, Grid, Typography } from '@mui/material';
import React, { Fragment, useContext, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import dayjs from 'dayjs';

import { House, Trash } from '@vectopus/atlas-icons-react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '@/utils/appContext';
import { IOrder, IPackageCode, IPackages } from '@/interfaces/bookingContext';
import {
  currencyFormat, g, getAssetsUrl,
  getDateRangesOfProperty,
  getPropertiesOfCart,
  getXXX, gEventAddExtraArg,
  hunify,
  IPropertyWithOrders, website
} from '@/utils/helpers';
import { IProperty, IStays } from '@/interfaces/huWebsite';
import { useNavigate } from 'react-router-dom';
import GuestsList from './step3/components/GuestList';
import AssuranceIncluded from './AssuranceIncluded';
import { deletePackageToItem } from '@/utils/requests';
import accommodationsVP from '../assets/icons/accommodations_vp.svg'


const Cart = ({ origin }: { origin: string }) => {


  const appContext = useContext(AppContext);
  const { classes } = useStyles();
  const { t } = useTranslation();

  const navigate = useNavigate();

  const items = appContext.cart;

  const propertiesOfCart: IProperty[] = getPropertiesOfCart(items, appContext.properties);

  const dateRangesOfProperty: any[] = getDateRangesOfProperty(items, propertiesOfCart);

  const xxx = getXXX(propertiesOfCart, dateRangesOfProperty);

  const editItemFromCart = (item: IOrder) => {
    navigate(`/orders/${item.item_id}`);
    appContext.setDrawerCart(false);
  };

  const priceOfItemWithoutPackages = (i: IOrder): number => {
    if (!i.TotalStay) return i.Price; // Check is ok
    if (i.PackageCode.length === 0) return i.TotalStay;

    return i.PackageCode.reduce((previousValue, currentValue) => {
      if (currentValue.Price && currentValue.FrequencyCode === 'EPF') {
        if (dayjs(i.GuestDeparture).diff(i.GuestArrival, 'day') > 2) {
          return previousValue - (currentValue?.Price * 2 || 0);
        } else {
          return previousValue - (currentValue?.Price || 0);
        }
      } else if (currentValue.Price && currentValue.FrequencyCode === 'PET') {
        const d = dayjs(i.GuestDeparture).diff(i.GuestArrival, 'day');
        const f = d < 4 ? 1 : (d < 8 ? 2 : 3);
        return previousValue - (currentValue?.Price * f || 0);
      } else if (currentValue.FrequencyCode === 'ALL') {
        const d = dayjs(i.GuestDeparture).diff(i.GuestArrival, 'day');
        return previousValue - ((currentValue?.Price || 0) * d);

      } else {
        return previousValue - (currentValue?.Price ?? 0);
      }
    }, i.TotalStay);
  };

  const getSumTotalStayOfOrders = (orders: string[]): number => {
    return orders.reduce((sum, item_id) => {
      const order = items.find((item) => item.item_id === item_id);
      if (!order) return sum;
      const price = order.TotalStay ?? order.Price
      const points = order.points ?? 0; // Default to 0 if undefined
      return sum + price - (Math.floor(points / 4 * 100) / 100);
    }, 0);
  };

  const handleItemToRemove = (i: IOrder) => {
    appContext.setOpenModalDeleteItem(true);
    appContext.setItemToRemove(i);
  };

  const numberOfPropertiesInCart = items.reduce((previousValue, currentValue) => {
    previousValue[currentValue.Property] = previousValue[currentValue.Property] || [];
    previousValue[currentValue.Property].push(currentValue);
    return previousValue;
  }, Object.create(null));

  console.log(xxx)

  return (
    <>
      {xxx.map((property: IPropertyWithOrders, index: number) => (
        <Fragment key={index}>
          <Box className={classes.cart} p={2} mb={4}>
            <Typography variant={'body1'} component={'p'}>
              {t('Your_vacation_at')}
            </Typography>
            <Typography variant={'h6'} component={'h6'} dangerouslySetInnerHTML={hunify(property?.title)}
                        sx={{ fontFamily: 'Circular Spotify Tx T Bold' }}></Typography>
            <Box mt={2} mb={2}>
              <Typography variant={'body1'} component={'span'}>
                {property.propertyInfo?.location}
              </Typography>
            </Box>

            <img
              src={getAssetsUrl(property.propertyInfo?.gallery[0])}
              alt={'preview'}
              height={240}
              width={'100%'}
            />

            {property.stays?.map((item, index) => {
              return (
                <Box key={Object.values(item).join()}>
                  <Box>
                    <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                      <Grid item>
                        <Typography variant={'body1'} component={'p'} sx={{ fontFamily: 'Circular Spotify Tx T Bold' }}>
                          {/*{t('Stay')} {index + 1}*/}
                          {property.stays && property?.stays.length > 1 && `Stay ${index + 1}`}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography variant={'body1'} component={'p'} pt={2} pb={1}>
                          {dayjs(item.GuestArrival).format('DD/MM/YY')}
                          {' - '}
                          {dayjs(item.GuestDeparture).format('DD/MM/YY')}
                        </Typography>
                      </Grid>
                    </Grid>

                    <hr />

                    <Box pt={3} sx={{ display: 'flex', alignItems: 'center' }}>
                      {
                        website.code !== 'VP' ? (
                          <>
                            <House size={30} />
                            <Typography variant={'h4'} component={'h4'} sx={{ lineHeight: '22px' }} pl={2}>
                              {t('accommodation_and_extras')}
                            </Typography>
                          </>
                          ) : (
                          <>
                            <img src={accommodationsVP} width={30} height={30} alt={'accommodations'}/>
                            <Typography variant={'h4'} component={'h4'} sx={{ lineHeight: '22px' }} pl={2}>
                              {t('accommodations')}
                            </Typography>
                          </>
                        )
                      }
                    </Box>

                    {item.orders.map((order: string, index: number) => {
                      const i = items.find((item: IOrder) => item.item_id === order);
                      return (
                        i && (
                          <Fragment key={index}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }} mt={2}>
                              {
                                origin === 'DrawerCart' && (
                                  <Box
                                    pt={1}
                                    pr={2}
                                    onClick={() => handleItemToRemove(i)}
                                    sx={{ cursor: 'pointer' }}>
                                    <Trash size={24} color={'red'} />
                                  </Box>
                                )
                              }
                              <Grid
                                container
                                direction={'row'}
                                justifyContent={'center'}
                                alignItems={'flex-start'}>
                                <Grid item xs={8}>
                                  <Typography
                                    variant={'body1'}
                                    component={'p'}
                                    dangerouslySetInnerHTML={hunify(property.property === 'EV' ?
                                      property?.roomfeed?.find((room) => i?.RoomType.slice(-3) === room.room_id)?.title! :
                                      property?.roomfeed.find((room) => {return room.room_id === i.RoomType})?.title!)}></Typography>
                                  <Typography variant={'body2'} component={'span'}>
                                    <GuestsList item={i} />
                                  </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                  <Typography component={'h5'} variant={'h5'} textAlign={'right'}>
                                    € {currencyFormat(priceOfItemWithoutPackages(i))}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Box>
                            <BookedExtraList params={{ i, origin }} />
                            <Box>
                              {
                                origin === 'DrawerCart' && (
                                  <Typography
                                    variant={'h6'}
                                    component={'span'}
                                    onClick={() => editItemFromCart(i)}
                                    sx={{
                                      cursor: 'pointer',
                                      fontSize: 14,
                                      textDecoration: 'underline',
                                      textTransform: 'lowercase'
                                    }}>
                                    + {t('add_extra')}
                                  </Typography>
                                )
                              }
                            </Box>

                            {
                              (i.points > 0) && (
                                <Box className={classes.boxPoints}>
                                  <Grid container
                                        direction={'row'}
                                        alignItems={'center'}
                                        justifyContent={'space-between'}>
                                    <Grid item>
                                      <Typography variant={'body2'}
                                                  component={'p'}>
                                        {t('stai_utilizzando_n_punti', {
                                          points: i.points
                                        })}</Typography>
                                    </Grid>
                                    <Grid item>
                                      <Typography variant={'body1'} component={'p'} pl={1}>
                                        - € {currencyFormat(i.points / 4)}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Box>
                              )
                            }

                            {(i.RateCode.includes('AS') || i.RateCode.includes('AX')) && i.Property !== 'BK' && <AssuranceIncluded />}
                          </Fragment>
                        )
                      );
                    })}

                    {/*{index > 1 && (
                      <>
                        <hr style={{ border: '2px solid #000', marginTop: '16px' }} />

                        <Grid
                          container
                          direction={'row'}
                          alignItems={'flex-end'}
                          justifyContent={'space-between'}
                          pt={2}>
                          <Grid item xs={6}>
                            <Typography variant={'h6'} component={'h6'}>
                              {t('Importo_soggiorno')} {index + 1}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography component={'h5'} variant={'h5'} textAlign={'right'}>
                              €{' '}
                              {item.orders.map((o: string) => {
                                const i = items.find((item: IOrder) => item.item_id === o);
                                return i && currencyFormat(i?.TotalStay);
                              })}
                            </Typography>
                          </Grid>
                        </Grid>
                      </>
                    )}*/}
                  </Box>

                  <hr style={{ border: '2px solid #000', marginTop: '16px' }} />

                  <Grid
                    container
                    direction={'row'}
                    alignItems={'flex-end'}
                    justifyContent={'space-between'}
                    pt={2}>
                    <Grid item xs={6}>
                      <Typography variant={'h5'} component={'h5'}>
                        {t('total_stay')}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography component={'h4'} variant={'h4'} className={classes.totalStay}>
                        € {currencyFormat(getSumTotalStayOfOrders(item.orders))}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    direction={'row'}
                    alignItems={'flex-end'}
                    justifyContent={'flex-end'}
                    textAlign={'right'}>
                    <Grid item xs={6}>
                      <Typography component={'span'} variant={'body2'} sx={{ fontSize: 10 }}>
                        {t('Tasse di soggiorno non incluse')}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
          </Box>
        </Fragment>
      ))}

      <Box>
        { (xxx.length > 1 || xxx.find( x => x.stays.length > 1) ) && (
          <Card sx={{ boxShadow: 'none!important', padding: '0!important', backgroundColor: 'white!important' }}>
            <Box p={3}>
              <hr style={{ border: '6px solid black' }} />
              <Grid
                container
                direction={'row'}
                alignItems={'flex-end'}
                justifyContent={'space-between'}
                pt={2}>
                <Grid item xs={6}>
                  <Typography variant={'h5'} component={'h5'}>
                    {t('Totale_vacanza')}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography component={'h4'} variant={'h4'} className={classes.totalStay}>
                    €{' '}
                    {currencyFormat(
                      items.reduce((acc: number, item: IOrder) => {
                        const price = item.TotalStay ?? item.Price
                        return acc + price - (Math.floor(item.points / 4 * 100) / 100);
                      }, 0)
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                direction={'row'}
                alignItems={'flex-end'}
                justifyContent={'flex-end'}
                textAlign={'right'}>
                <Grid item xs={6}>
                  <Typography component={'span'} variant={'body2'} sx={{ fontSize: 10 }}>
                    {t('Tasse di soggiorno non incluse')}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Card>
        )}
      </Box>
    </>
  );
};

export default Cart;

const BookedExtraList = (props: any) => {
  const appContext = useContext(AppContext);
  const useStyles = makeStyles()((theme) => {
    return {
      stayRecapBox: {
        backgroundColor: '#F2F2F2',
        borderRadius: 4,
        '.MuiGrid-root': {
          display: 'flex'
        }
      }
    };
  });
  const { classes } = useStyles();

  const navigate = useNavigate();
  const editElFromCart = (item: IOrder) => {
    navigate(`/orders/${item.item_id}`);
    appContext.setDrawerCart(false);
  };

  // const [isDeletingPack, setIsDeletingPack] = useState<boolean>(false);

  const removePackFromEl = (pack: IPackageCode, item: IOrder) => {
    if (!pack.attr) return;

    const key = `${item.item_id} ${pack.attr}`;
    const x = [...appContext.cartPending];
    x.push(key);
    appContext.setCartPending(() => {
      return [...x];
    });

    pack.edit = true;

    deletePackageToItem(item.cart_id, item.item_id, pack.attr).then(() => {
      g('event', 'remove_from_cart_extra_v2', gEventAddExtraArg(pack, item, appContext));
    }).catch((error) => {
      // appContext.cartPending = [...appContext.cartPending.filter((task) => task !== key)];
      // appContext.setCartPending([...appContext.cartPending]);
      console.error(error);
    })
      .finally(() => {
        pack.edit = false;
      });

  };

  const {t} = useTranslation();

  return props.params.i && props.params.i.PackageCode && props.params.i.PackageCode.length > 0 ? (
    <Box mb={1}>
      {props.params.i.PackageCode.map((pack: IPackageCode, index: number) => (
        <Box className={classes.stayRecapBox} p={2} mt={1} key={index}>
          <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
            <Grid item>
              {
                (window.location.href.includes('orders') || window.location.href.includes('search')) && (
                  <>
                    {
                      pack.edit ? (
                        <Box pr={1}>
                          <CircularProgress sx={{ width: '24px!important', height: '24px!important', color: 'black' }}
                                            color="inherit" />
                        </Box>
                      ) : (
                        <>
                          {((pack.attr !== 'EPFA' && pack.PackageCode !== 'ELP1' && pack.PackageCode !== 'ELP2' && pack.PackageCode !== 'ELP3' && pack.PackageCode !== 'ELP4') && appContext.searchForms[appContext.orderIndex].Pets > 0) || pack.attr !== 'EMUS' && (
                              <Box onClick={() => removePackFromEl(pack, props.params.i)} sx={{cursor: 'pointer'}} pr={1}>
                                <Trash size={24}/>
                              </Box>
                          )}
                        </>
                      )
                    }
                  </>
                )
              }
              <Typography variant={'body2'} component={'p'}>
                {pack.Name}
              </Typography>
            </Grid>
            <Grid item>
              {
                pack.FrequencyCode === 'EPF' && (
                  <>
                    {
                      dayjs(props.params.i.GuestDeparture).diff(props.params.i.GuestArrival, 'day') > 2 ? (
                        <Typography variant={'body1'} component={'p'} pl={1} textAlign={'right'}>
                          € {currencyFormat(pack.Price! * 2)}
                        </Typography>
                      ) : (
                        <Typography variant={'body1'} component={'p'} pl={1} textAlign={'right'}>
                          € {currencyFormat(pack.Price)}
                        </Typography>
                      )
                    }
                  </>
                )
              }

              {
                pack.FrequencyCode === 'PET' && (
                  <Typography variant={'body1'} component={'p'} pl={1} textAlign={'right'}>
                    € {currencyFormat(pack.Price! * (dayjs(props.params.i.GuestDeparture).diff(props.params.i.GuestArrival, 'day') < 4 ? 1 : (dayjs(props.params.i.GuestDeparture).diff(props.params.i.GuestArrival, 'day') < 8 ? 2 : 3)))}
                  </Typography>
                )
              }

              {
                pack.FrequencyCode === 'ALL' && (
                  <Typography variant={'body1'} component={'p'} pl={1} textAlign={'right'}>
                    € {currencyFormat((pack?.Price || 0) * dayjs(props.params.i.GuestDeparture).diff(props.params.i.GuestArrival, 'day'))}
                  </Typography>
                )
              }

              {
                !['EPF', 'PET', 'ALL'].includes(String(pack.FrequencyCode)) && (
                  <>
                    {
                      pack.Price! > 0 ? (
                        <Typography variant={'body1'} component={'p'} pl={1} textAlign={'right'}>
                          € {currencyFormat(pack.Price)}
                        </Typography>
                      ) : (
                        <Typography variant={'body1'} component={'p'} pl={1} textAlign={'right'}>
                          {t('free')}
                        </Typography>
                      )
                    }
                  </>
                )
              }
            </Grid>
          </Grid>
        </Box>
      ))}
    </Box>
  ) : (
    <></>
  );
};


const useStyles = makeStyles()((theme) => {
  return {
    stayRecapBox: {
      backgroundColor: '#F2F2F2',
      borderRadius: 4
    },
    totalStay: {
      borderBottom: '5px solid' + theme.palette.generalUnderlineColor.main,
      display: 'inline-flex',
      float: 'right',
      lineHeight: '16px'
    },
    confirmBtn: {
      marginTop: 30,
      width: '100%',
      backgroundColor: 'black',
      color: 'white',
      borderRadius: theme.radius.formBorderRadius,
      fontSize: 24,
      borderColor: 'black',
      fontFamily: theme.typography.h6.fontFamily,
      '&:hover': {
        backgroundColor: 'black',
        color: 'white',
        borderColor: 'black'
      }
    },
    cart: {
      backgroundColor: '#FFF'
    },
    boxPoints: {
      backgroundColor: '#fef9d1',
      borderRadius: '4px',
      padding: '16px',
      marginTop: '4px'
    }
  };
});
